// Shared constants for the application

export const categories = [
  'Tops',
  'Bottoms',
  'Dresses',
  'Outerwear',
  'Footwear',
  'Accessories',
  'Activewear',
  'Sleepwear',
  'Formalwear',
  'Swimwear',
];
